<template>
    <div id="app" :class="{ 'pass-pay-root': isPassPay, 'poster-root': isPoster, 'verify-root': isVerify }">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'App',
    computed: {
        isPassPay() {
            return this.$route.path === '/pass-pay'
        },
        isPoster() {
            return this.$route.path === '/poster'
        },
        isVerify() {
            return this.$route.path === '/verify' || this.$route.path.indexOf('/verify/') === 0
        },
    },
}
</script>

<style>
*{
    padding: 0;
    margin: 0;
}
html, body, #app {
    height: 100%;
    overflow: hidden;
}
#app.pass-pay-root,
#app.poster-root,
#app.verify-root {
    overflow: auto;
}
#app {
    padding: 0;
    margin: 0;
}
body {
  font-family: 'Gravity-V546', sans-serif;
}
.app-nav::-webkit-scrollbar {
  display: none;
  /* Chrome Safari */
}

::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 8px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 8px;
}

::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 8px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #eaeaea;
}

::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  background: #fff;
}
</style>
